/**
 * `wpp::table`
 *
 * Bulk selection, held on the Livewire component rather than here, because the
 * server is what acts on it. That makes this an interface as much as a
 * component: the host has to expose `selectionMode` (`'individual'` or
 * `'all'`), `selectedIds` and `deselectedIds`.
 *
 * `'all'` is stored as an exclusion list on purpose — "everything except these
 * four" survives a page change, where a list of ids for a hundred thousand rows
 * does not.
 */
export default () => ({
    toggleBulkSelection(id) {
        const mode = this.$wire.selectionMode;

        if (mode === 'individual') {
            const ids = [...this.$wire.selectedIds];
            const idx = ids.indexOf(id);

            if (idx > -1) {
                ids.splice(idx, 1);
            } else {
                ids.push(id);
            }

            this.$wire.set('selectedIds', ids, false);
        } else if (mode === 'all') {
            const ids = [...this.$wire.deselectedIds];
            const idx = ids.indexOf(id);

            if (idx > -1) {
                ids.splice(idx, 1);
            } else {
                ids.push(id);
            }

            this.$wire.set('deselectedIds', ids, false);
        }
    },

    isBulkSelected(id) {
        const mode = this.$wire.selectionMode;

        if (mode === 'individual') {
            return this.$wire.selectedIds.includes(id);
        }

        if (mode === 'all') {
            return !this.$wire.deselectedIds.includes(id);
        }

        return false;
    },
});
